import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { BackendApiService } from './backend-api.service';
import { SpaqFireDb } from './spaq-fire-db.service';
import { Vehicule } from './shared-constants';
import { Store } from '@ngrx/store';

import { Observable, zip } from 'rxjs';
import { first, map, switchMap, take, tap } from 'rxjs/operators';

@Injectable()
export class VehiclesService {
	private _vehicles = [];

	get endPoint() {
		return this.afAuth.user.pipe(
			take(1),
			map(u => {
				return `/user/${u.uid}/vehicles`;
			})
		);
	}

	constructor(
		private db: SpaqFireDb,
		private afAuth: AngularFireAuth,
		private store: Store<any>,
		private backendApi: BackendApiService
	) {}

	create(data: Vehicule) {
		return this.backendApi.vehicleCreate(data);
	}

	getBrands(year: string) {
		return this.db.vehicleBrands$(year).pipe(
			tap(x => {
				if (x) {
					x.push('Autre');
				}
				return x;
			})
		);
	}

	getData(year, brand) {
		return zip(this.getYears(), this.getBrands(year), this.getModels(year, brand)).pipe(
			map(data => ({
				years: data[0],
				brands: data[1],
				models: data[2]
			}))
		);
	}

	getModels(year: string, brand: string) {
		return this.db.vehicleModels$(brand, year);
	}

	getModelsByYearAndBrand(year: string, brand: string) {
		return this.db.vehicleModelsSnapshot$(brand, year).pipe(map(a => a.map(model => ({ model: model.payload.val(), id: model.key }))));
	}

	getYears() {
		return this.db.vehicleYears$().pipe(first());
	}

	get vehicles() {
		return this._vehicles;
	}

	getVehicle(index) {
		return this._vehicles[index] || null;
	}

	getVehiclesCount() {
		return this._vehicles.length;
	}

	hydrate() {
		return this.afAuth.user.pipe(
			switchMap(u => this.db.userVehicles$<Vehicule[]>(u.uid)),
			tap(x => {
				this._vehicles = x || [];
			})
		);
	}

	update(data: Vehicule) {
		return this.backendApi.vehicleUpdate(data);
	}
}
